import { render, staticRenderFns } from "./TempGame.vue?vue&type=template&id=6ba349dc&scoped=true&"
import script from "./TempGame.vue?vue&type=script&lang=js&"
export * from "./TempGame.vue?vue&type=script&lang=js&"
import style0 from "./TempGame.vue?vue&type=style&index=0&id=6ba349dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba349dc",
  null
  
)

export default component.exports